import { sagas as editorSagas } from '@sloyd/app-editor';
import { sagas as labSagas } from '@sloyd/app-labs';
import { sagas as authSagas } from '@sloyd/auth';
import { saga as sagaApi } from './saga.api';
import { saga as sagaBootstrap } from './saga.bootstrap';
import { saga as sagaCache } from './saga.cache';
import { saga as sagaLogs } from './saga.logs';
import { saga as sagaNavigation } from './saga.navigation';
import { saga as sagaOnBoarding } from './saga.onboarding';
import { saga as sagaPurchase } from './saga.purchase';
import { saga as sagaSentry } from './saga.sentry';
import { saga as sagaSettings } from './saga.settings';
import { saga as sagaTesters } from './saga.testers';
import { saga as sagaUser } from './saga.user';

export const allSagas: any = {
  'sloyd.bootstrap': sagaBootstrap,
  'sloyd.navigation': sagaNavigation,
  'sloyd.api': sagaApi,
  'sloyd.cache': sagaCache,
  'sloyd.user': sagaUser,
  'sloyd.logs': sagaLogs,
  'sloyd.settings': sagaSettings,
  'sloyd.testers': sagaTesters,
  'sloyd.sentry': sagaSentry,
  'sloyd.purchase': sagaPurchase,
  'sloyd.onboarding': sagaOnBoarding,
  ...authSagas,
  ...editorSagas,
  ...labSagas,
};
